/** Довжина коду TOTP (RFC 6238, 30 с): 6 цифр. */
const MFA_CODE_LENGTH = 6;

/** Код із поля: лише цифри (пробіли й дефіси зі вставленого «123 456» відкидаються), не довше 6. Чиста функція. */
export const mfaCodeOf = (raw: string): string => raw.replace(/\D/g, '').slice(0, MFA_CODE_LENGTH);

/** Код повний — можна надсилати. Чиста функція. */
export const isMfaCode = (code: string): boolean => code.length === MFA_CODE_LENGTH;

/** Секрет Base32 групами по 4 символи для ручного введення («JBSW Y3DP …»). Чиста функція. */
export const secretGroups = (secret: string): string => (secret.replace(/\s+/g, '').match(/.{1,4}/g) ?? []).join(' ');
